import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import { PluginKey } from '@atlaskit/editor-prosemirror/state';
import { lazyBodiedSyncBlockView } from '../nodeviews/bodiedLazySyncedBlock';
import { lazySyncBlockView } from '../nodeviews/lazySyncedBlock';
import { trackSyncBlocks } from './utils/track-sync-blocks';
export var syncedBlockPluginKey = new PluginKey('syncedBlockPlugin');

// eslint-disable-next-line @typescript-eslint/no-empty-object-type

export var createPlugin = function createPlugin(options, pmPluginFactoryParams, syncBlockStore, api) {
  return new SafePlugin({
    key: syncedBlockPluginKey,
    state: {
      init: function init() {
        return {};
      },
      apply: function apply(tr, currentPluginState) {
        var meta = tr.getMeta(syncedBlockPluginKey);
        if (meta) {
          return meta;
        }
        return currentPluginState;
      }
    },
    props: {
      nodeViews: {
        syncBlock: lazySyncBlockView({
          options: options,
          pmPluginFactoryParams: pmPluginFactoryParams,
          api: api,
          syncBlockStore: syncBlockStore
        }),
        bodiedSyncBlock: lazyBodiedSyncBlockView({
          pluginOptions: options,
          pmPluginFactoryParams: pmPluginFactoryParams,
          api: api,
          syncBlockStore: syncBlockStore
        })
      }
    },
    view: function view(editorView) {
      syncBlockStore.setEditorView(editorView);
      return {
        destroy: function destroy() {
          syncBlockStore.setEditorView(undefined);
        }
      };
    },
    filterTransaction: function filterTransaction(tr, state) {
      // Ignore transactions that don't change the document
      // or are from remote (collab) or already confirmed sync block deletion
      // We only care about local changes that change the document
      // and are not yet confirmed for sync block deletion
      if (!tr.docChanged || !(syncBlockStore !== null && syncBlockStore !== void 0 && syncBlockStore.requireConfirmationBeforeDelete()) || Boolean(tr.getMeta('isRemote')) || Boolean(tr.getMeta('isConfirmedSyncBlockDeletion'))) {
        return true;
      }
      var _trackSyncBlocks = trackSyncBlocks(syncBlockStore, tr, state),
        removed = _trackSyncBlocks.removed;
      if (removed.length > 0) {
        // If there are source sync blocks being removed, and we need to confirm with user before deleting,
        // we block the transaction here, and wait for user confirmation to proceed with deletion.
        // See editor-common/src/sync-block/sync-block-store-manager.ts for how we handle user confirmation and
        // proceed with deletion.
        syncBlockStore.deleteSyncBlocksWithConfirmation(tr, removed);
        return false;
      }
      return true;
    },
    appendTransaction: function appendTransaction(trs, _oldState, newState) {
      trs.filter(function (tr) {
        return tr.docChanged;
      }).forEach(function (tr) {
        syncBlockStore === null || syncBlockStore === void 0 || syncBlockStore.rebaseTransaction(tr, newState);
      });
      return null;
    }
  });
};